import { useLayoutEffect, useRef } from "react";

// Tek satırlık değer (tutar vb.) kapsayıcıya sığmazsa yazı boyutunu küçültür — ekran genişliği ne olursa olsun sayı tam görünür
export function FitText({ children, max = 24, min = 11, className = "", ...rest }) {
  const ref = useRef(null);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const fit = () => {
      let s = max;
      el.style.fontSize = `${s}px`;
      while (s > min && el.scrollWidth > el.clientWidth + 1) { s -= 1; el.style.fontSize = `${s}px`; }
    };
    fit();
    const ro = new ResizeObserver(fit);
    ro.observe(el);
    return () => ro.disconnect();
  }, [children, max, min]);
  return <span ref={ref} className={`block whitespace-nowrap overflow-hidden ${className}`} {...rest}>{children}</span>;
}
